import { NgOptimizedImage } from "@angular/common";
import { Component } from "@angular/core";

@Component({
  selector: "app-recruitment",
  templateUrl: "./recruitment.component.html",
  styleUrls: ["./recruitment.component.scss"],
  imports: [NgOptimizedImage],
})
export class RecruitmentComponent {}
